export default __webpack_public_path__ + "static/media/garden.b5c33a50.webp";